import { render, staticRenderFns } from "./MatchesMobile.vue?vue&type=template&id=37183f96&scoped=true&"
import script from "./MatchesMobile.vue?vue&type=script&lang=js&"
export * from "./MatchesMobile.vue?vue&type=script&lang=js&"
import style0 from "./MatchesMobile.vue?vue&type=style&index=0&id=37183f96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37183f96",
  null
  
)

export default component.exports